// @flow
import React, { type Node } from 'react';
import cn from 'classnames';

import PlainTooltip from 'app/common/ui-next/plain-tooltip';

import styles from './ApplyDescription.scss';


type Props = {
  description: ?string,
  children: Node,
  paint: string,
}

const ApplyDescription = ({ description, children, paint }: Props): Node => {
  if (description) {
    return (
      <PlainTooltip
        text={description}
        className={cn(styles.container, styles[paint])}
        popupContentClassName={styles[paint]}
        popupArrowClassName={styles[paint]}
      >
        {children}
      </PlainTooltip>
    );
  }

  return children;
};

export default ApplyDescription;
